import {
  Component,
  Input,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Transaction } from '../../models/transaction';
import { RazorpayTransactionRequest } from '../../models/razorpay-payment-details';
import { RazorpayService } from '../../services/razorpay.service';
import { MerchantResponseComponent } from '../../merchant-response/merchant-response.component';
import { GlobalAppData } from '../../models/global-app-data';
import { MerchantResponseData } from '../../models/merchant-models';
import { Constants } from '../../constants/constants';
import { firstValueFrom, interval, map, Observable, shareReplay, startWith, takeWhile } from 'rxjs';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-indpaystub',
  templateUrl: './indpaystub.component.html',
  styleUrls: ['./indpaystub.component.css'],
  standalone: false,
})
export class IndpaystubComponent implements OnInit {
  @Input() orderData: Transaction;
  @Output() onSuccess = new EventEmitter<any>();
  @Output() onError = new EventEmitter<any>();
  @ViewChild(MerchantResponseComponent) public merchantResponseComponent;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  razorPayStatus:string;
  counter$!: Observable<number>;
  timmer: any;
  status: any;

  paymentMethods = [
    { label: 'UPI', icon: '⚡', code: 'upi' },
    { label: 'Credit Card', icon: '💳', code: 'credit-card' },
    { label: 'Debit Card', icon: '💳', code: 'debit-card' },
    { label: 'Netbanking', icon: '🏦', code: 'netbanking' },
    { label: 'Paylater', icon: '🕐', code: 'paylater' },
    { label: 'Wallet', icon: '👛', code: 'wallet' },
    { label: 'EMI', icon: '📅', code: 'emi' },
  ];

  stubOptions = [
    { value: 'SUCCESS', label: 'Success' },
    { value: 'FAILED', label: 'Failed' },
    { value: 'CANCEL', label: 'Cancel' }
  ];

  selectedMethod = '';
  selectedMethodCode = '';
  stubUserChoice = '';

  dropdownOpen = false;
  isSubmitting = false;

  private modalRef: NgbModalRef;
  sessionId: string;
  alertEnabled:boolean;
  alertText:string;

  constructor(
    private modalService: NgbModal, 
    private cdr: ChangeDetectorRef,
    private rzPayService: RazorpayService,
    public gd:GlobalAppData,private sessionService: SessionService
  ) {
    this.sessionId = (this.sessionService.sessionId);
  }
   async ngOnInit() {
    await this.initCountdown$();
    this.alertEnabled=this.gd.oscConfig?.indiaAlertEnabled;
    this.alertText=this.gd.oscConfig?.indiaTextAlert;
   }

   private async initCountdown$() {
      this.timmer = this.gd.oscConfig.sessionTimeoutScnds;
  
      let startSeconds = 0;
      try {
      this.status = await firstValueFrom(this.sessionService.get(this.sessionId));
  
  
      startSeconds = Math.max(0, Number(this.status?.balanceTTLInSeconds ?? 0));
  
      } catch (err) {
        console.error('Failed to load session status', err);
      }
  
      if (!Number.isFinite(startSeconds) || startSeconds <= 0) {
        const mins = Number(this.timmer ?? 0);
        startSeconds = mins > 0 ? Math.floor(mins * 60) : 0;
      }
  
     this.counter$ = interval(1000).pipe(
      startWith(0),
        map((ticks) => Math.max(0, startSeconds - ticks - 1)),
        takeWhile((val) => val > 0, true),
        shareReplay({ bufferSize: 1, refCount: true })
      );
      firstValueFrom(this.counter$).then(v => console.log('counter$ first emission (secs):', v));
      
    }
  
    
    formatMMSS(totalSeconds?: number): string {
      const s = Math.max(0, Number(totalSeconds ?? 0));
      const m = Math.floor(s / 60);
      const sec = s % 60;
     return `${m}:${String(sec).padStart(2, '0')}`;
    }
  

  openStatusModal() {
  this.selectedMethod = '';
  this.selectedMethodCode = '';
  this.stubUserChoice = '';
  this.dropdownOpen = false;
  this.isSubmitting = false;

  this.modalRef = this.modalService.open(this.modalContent, {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    windowClass: 'premium-stub-modal',
  });

  // 🔑 HANDLE CLOSE / DISMISS
  this.modalRef.result.then(
    (result) => {
      // CLOSED via modalRef.close()
      console.log('Modal closed with result:', result);
      // Do nothing here (success flow already handled in submitStatus)
    },
    (reason) => {
      // DISMISSED via × button / ESC / backdrop
      console.log('Modal dismissed:', reason);
      this.onCloseDismissModel();
    }
  );

  this.cdr.detectChanges();
}


  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectMethod(method: any) {
    this.selectedMethod = method.label;
    this.selectedMethodCode = method.code;
    this.dropdownOpen = false;
    this.stubUserChoice = '';
  }

  onRadioChange(option: any) {
    console.log('Radio button changed to:', option.value);
    console.log('Option label:', option.label);
  }

  /**
   * Generate a random 3-digit number
   */
  private generateRandomThreeDigitNumber(): string {
    return Math.floor(100 + Math.random() * 900).toString();
  }

  /**
   * Generate a random alphanumeric string
   * @param length - Length of the string
   */
  private generateRandomAlphanumeric(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  /**
   * Generate razorpay payment ID
   * Format: razorpay_{3digit}_{status}_{paymentMethod}
   */
  private generateRazorpayPaymentId(): string {
    const randomNumber = this.generateRandomThreeDigitNumber();
    const status = this.stubUserChoice.toLowerCase();
    const method = this.selectedMethodCode.toLowerCase();
    
    return `razorpay_${randomNumber}_${status}_${method}`;
  }

  /**
   * Generate razorpay order ID
   * Format: order_{randomAlphanumeric}
   */
  private generateRazorpayOrderId(): string {
    const randomStr = this.generateRandomAlphanumeric(13);
    return `order_${randomStr}`;
  }

  /**
   * Generate razorpay signature (mock hex string)
   * Format: 128 character hex string
   */
  private generateRazorpaySignature(): string {
    const hexChars = '0123456789abcdef';
    let signature = '';
    for (let i = 0; i < 128; i++) {
      signature += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
    }
    return signature;
  }

  /**
   * Create the RazorpayTransactionRequest payload
   */
  private createRazorpayPayload(): RazorpayTransactionRequest {
    const epmsOrderId = this.orderData?.order?.epmsOrderId || '';
    const razorpayPaymentId = this.generateRazorpayPaymentId();
    const razorpayOrderId = this.orderData?.razorPayOrderId || this.generateRazorpayOrderId();
    const razorpaySignature = this.generateRazorpaySignature();

    const payload: RazorpayTransactionRequest = {
      epmsOrderId: epmsOrderId,
      razorpayPaymentId: razorpayPaymentId,
      razorpayOrderId: razorpayOrderId,
      razorpaySignature: razorpaySignature,
      status:Constants.RZ_STATUS_SUCCESS,
      error: null
    };

    if (this.stubUserChoice === 'FAILED') {
      payload.status= "FAILED"
      payload.error = {
        code: 'BAD_REQUEST_ERROR',
        description: 'Payment failed',
        source: 'customer',
        step: 'payment_authentication',
        reason: 'payment_failed',
        field: null
      };
    }

     if (this.stubUserChoice === 'CANCEL') {
      payload.status = Constants.RZ_STATUS_CANCELLED;
      payload.error = {
        code: '203',
        description: 'Cancel By user',
        source: 'customer',
        step: 'payment_authentication',
        reason: 'payment_cancelled',
        field: null
      };
    }

    return payload;
  }

  async submitStatus() {
    if (!this.selectedMethodCode || !this.stubUserChoice || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    try {
      console.log('=== STUB PAYMENT SUBMISSION ===');
      console.log('Payment Method:', this.selectedMethodCode);
      
      const razorPayReq = this.createRazorpayPayload();

      console.log('Generated Razorpay Payload:', JSON.stringify(razorPayReq, null, 2));
      console.log('Transaction ID:', this.orderData.orderTransactionId);
      console.log('EPMS Order ID:', razorPayReq.epmsOrderId);
      console.log('================================');

      const response = await this.rzPayService.captureRazorpayFinalResponse(
        this.orderData.orderTransactionId,
        razorPayReq
      );

      console.log('API Response:', response);

      this.modalRef.close(razorPayReq);

      if (this.stubUserChoice === 'SUCCESS') {
        this.onSuccess.emit(response);
        this.redirectToMerchantSuccessURL();
      } else {
        this.onError.emit(response);
        this.handleError();
      }

    } catch (error) {
      console.error('Error occurred during API call:', error);
      this.isSubmitting = false;
      
      this.modalRef.close();
      
      this.onError.emit(error);
      
      this.handleError();
    }
  }

  onCloseDismissModel(){
    this.handleError();
  }
    
    handleError() {
      this.razorPayStatus = 'paymentError';
      this.redirectToMerchantRejectURL();
    }
  
  
    redirectToMerchantSuccessURL(): void {
      let merchantSuccessURL = this.gd.orderTransaction.order.merchantSuccessURL;
      console.log("razorpay gd ---- ", this.gd.transId)
      if (!merchantSuccessURL) {
        merchantSuccessURL = this.gd.oscConfig.successUrl;
      }
      
      console.log("Redirecting to:", merchantSuccessURL);
      this.redirectToMerchant(merchantSuccessURL);
    }
    
    redirectToMerchant(urlVal: string): void {
      sessionStorage.clear()
      const paymentActionData = {
        url: urlVal,
        orderTransaction: this.gd.orderTransaction,
        merchantPaymentReq: {},
      } as MerchantResponseData;
      this.merchantResponseComponent.sendResponseToMerchant('RAZORPAY', paymentActionData);
    }
  
    redirectToMerchantRejectURL(): void {
      let merchantRejectURL = this.gd.orderTransaction.order.merchantRejectURL;
      if (!merchantRejectURL) {
        merchantRejectURL = this.gd.oscConfig.rejectUrl;
      }
      this.redirectToMerchant(merchantRejectURL);
    }
}